/**
 * Where in its recording a node of a video stands: an event, a scene, a plate reading, a face of
 * a pass or a figure without one. Each carries its recording's document id and its span, so the
 * inspector can open the recording there and copy a link that does the same.
 */
export interface VideoMoment {
  documentId: string
  from: number
  to: number
}

/** The labels whose node is a stretch of a recording, and the properties holding its span. */
const SPANS: ReadonlyArray<{ label: string; from: string; to: string }> = [
  { label: 'VideoEvent', from: 't_start', to: 't_end' },
  { label: 'Scene', from: 't_start', to: 't_end' },
  { label: 'Plate', from: 't_start', to: 't_end' },
  { label: 'Face', from: 't_start', to: 't_end' },
  { label: 'PersonAppearance', from: 'time_from', to: 'time_to' },
]

const seconds = (value: unknown): number | null =>
  typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null

export function videoMoment(
  labels: readonly string[],
  properties: Record<string, unknown>
): VideoMoment | null {
  const span = SPANS.find(entry => labels.includes(entry.label))
  const documentId = properties.document_id
  if (!span || typeof documentId !== 'string' || !documentId) return null
  // A face of a photo has no span; only a pass of a recording does.
  if (span.label === 'Face' && properties.source !== 'video') return null
  const from = seconds(properties[span.from])
  if (from === null) return null
  const to = seconds(properties[span.to])
  return { documentId, from, to: to !== null && to >= from ? to : from }
}
